import React from 'react'
import useSiteData from '../../useSiteData'
import { getLocaleInfo } from '../../util/contentModelToData'

export default () =>
   <ul className="m-language-list u-list-unstyled">
      { useSiteData().locales.map(getLocaleInfo).map(({ code, name, flag, link }) =>
         <li key={ code } className="m-language-list__item">
            <a className="m-language-list__link" href={ link }>
               <img className="m-language-list__logo" src={ flag } alt={ name }/>
               <span className="u-visually-hidden">{ name }</span>
            </a>
         </li>
      ) }
   </ul>;
